import { useState, useCallback } from "react";

const COOKIE_CONSENT_KEY = "cookieConsent_v1";

type ConsentValue = "accepted" | "essential_only";

interface CookieConsentState {
  accepted: ConsentValue | null;
  accept: () => void;
  acceptEssentialOnly: () => void;
}

export function useCookieConsent(): CookieConsentState {
  const [accepted, setAccepted] = useState<ConsentValue | null>(() => {
    try {
      const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (stored === "accepted" || stored === "essential_only") return stored;
    } catch {
      // localStorage may be unavailable
    }
    return null;
  });

  const accept = useCallback(() => {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    } catch {
      // ignore
    }
    setAccepted("accepted");
  }, []);

  const acceptEssentialOnly = useCallback(() => {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, "essential_only");
    } catch {
      // ignore
    }
    setAccepted("essential_only");
  }, []);

  return { accepted, accept, acceptEssentialOnly };
}
